import Channels from '../base/channels';
import { module } from 'modujs';
import { getCoords } from '../utils/utilities';
import gsap from 'gsap';

export default class extends module {
  constructor(m) {
    super(m);
  }

  init() {
    this.DOM = {
      view: this.el,
    };
    this.fnResize = this.resize.bind(this);
    this.resize();
    Channels.on('window::smartresize', this.fnResize);
  }

  resize() {
    const coords = getCoords(this.$('content')[0]);
    gsap.set(this.$('dummy'), { height: coords.height - 5 });
    Channels.emit('scroll::soft::refresh');
  }

  destroy() {
    Channels.removeListener('window::smartresize', this.fnResize);
  }
}
